export default function printReportPerEmployee(idFuncionario, type, startDate, endDate, isSimple) {
  const token = localStorage.getItem("token");
  printSalesPerEmployee(token, idFuncionario, type, startDate, endDate, isSimple);
}

function printSalesPerEmployee(token, idFuncionario, type, startDate, endDate, isSimple) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/and/employee/group/A4/?auth=${token}&idFuncionario=${idFuncionario}&type=${type}&startDate=${startDate}&endDate=${endDate}&isSimple=${isSimple}`
  );
}